module.exports = __webpack_public_path__ + "img/6_126.01126554.png";